const LegalIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    {...props}>
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.02}
      d='M27.384 7.94 16.19 18.904l-.982 3.559 3.635-.962 11.195-10.962a1.81 1.81 0 0 0 0-2.597 1.903 1.903 0 0 0-2.653 0Z'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.02}
      d='m25.66 9.71 2.954 2.894a1.67 1.67 0 0 1 0 2.397l-2.887 2.827M15.21 22.457l-.952.936M23.755 19.073v8.248H5V5h18.755v4.11M8.242 9.936h12.055M8.242 14.19h9.316M8.242 18.44h5.871M8.242 22.69h4.401M30.047 7.912l1.217-1.191'
    />
  </svg>
)

export default LegalIcon
